export const MAX_RECORDING_MS = 60_000;

export type VoiceState =
  | "idle"
  | "starting"
  | "recording"
  | "transcribing"
  | "denied"
  | "error";

export type VoiceInput = {
  available: boolean;
  state: VoiceState;
  elapsedMs: number;
  message?: string;
  transcript?: string;
  liveText?: string;
  start: () => void;
  stop: () => void;
  cancel: () => void;
  clearTranscript: () => void;
};
